import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "./Dash.css";

function Dashboard() {
  const [logo, setLogo] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("Live");
  const [projects, setProjects] = useState([]);
  const [selectedDeleteId, setSelectedDeleteId] = useState("");

  const projectsCollection = collection(db, "projects");

  // Fetch projects from Firestore
  const fetchProjects = async () => {
    const data = await getDocs(projectsCollection);
    setProjects(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!logo || !name || !status) return alert("Please fill all fields");

    try {
      await addDoc(projectsCollection, { logo, name, status });
      alert("Project uploaded");
      setLogo("");
      setName("");
      setStatus("Live");
      fetchProjects();
    } catch (error) {
      alert("Error uploading project: " + error.message);
    }
  };

  const handleDelete = async () => {
    if (!selectedDeleteId) return alert("Select a project to delete");
    try {
      await deleteDoc(doc(db, "projects", selectedDeleteId));
      alert("Project deleted");
      setSelectedDeleteId("");
      fetchProjects();
    } catch (error) {
      alert("Error deleting project: " + error.message);
    }
  };

  return (
    <div className="dashboard" >
      <h2>Admin Dashboard</h2>

      <form className="form" onSubmit={handleUpload}>
        <input
          type="text"
          placeholder="Logo URL"
          value={logo}
          onChange={(e) => setLogo(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Project Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          required
        >
          <option value="Live">Live</option>
          <option value="Completed">Completed</option>
          <option value="On Hold">On Hold</option>
        </select>
        <button type="submit">Upload Project</button>
      </form>

      <div className="delete-section">
        <h3>Delete Project</h3>
        <select
          value={selectedDeleteId}
          onChange={(e) => setSelectedDeleteId(e.target.value)}
        >
          <option value="">-- Select Project --</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>
        <button onClick={handleDelete} disabled={!selectedDeleteId}>
          Delete Selected Project
        </button>
      </div>
    </div>
  );
}

export default Dashboard;
